import React, { Component } from 'react';
import { connect } from 'react-redux';
import Booking from '@solvhealth/types/interfaces/Booking';
import styled from 'styled-components';
import Button from '../../../components/SolvPatternLibrary/Button';
import { ACCOUNT_HOME_PATH, ADD_REVIEW_THANK_YOU } from '../../../constants/index';
import history from '../../../core/history';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
import { copy } from '../../../core/util/addReview';
import { isProviderGroupBooking } from '../../../core/util/booking';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import FlowTransition from '../transitions/FlowTransition';

const StyledButton = styled(Button).withConfig({ componentId: 'sc-1cbvkxy-0' })`
  width: 284px;
  border-radius: 10px;
`;

type Props = {
  flowState: string;
  starRating?: number;
  bookingId: string;
  pastBookings?: any;
  booking: Booking;
};

class ThankYou extends Component<Props> {
  handleClick = () => {
    const { pastBookings, bookingId, booking } = this.props;

    if (isProviderGroupBooking(booking)) {
      history.push(`/pass/${bookingId}`);
    } else {
      const userProfileId = pastBookings?.[bookingId]?.userProfileId;

      if (userProfileId) {
        history.replace(`${ACCOUNT_HOME_PATH}/${userProfileId}/manage?b=${bookingId}`);
      } else {
        history.push(`/pass/${bookingId}`);
      }
    }
  };

  renderThanks = () => {
    if (!this.props.starRating) {
      return null;
    }

    return (
      <div className={s.thanksContainer}>
        <img className={s.greenCheckmark} src="/images/icons/checkmark_green.svg" />
        {/* @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'numbe... Remove this comment to see the full error message */}
        <div className={s.thankYou}>{copy[this.props.starRating].thanksMessage}</div>

        <div className={s.timeoutContainer}>
          <div className={s.timeout} />
        </div>

        <div>
          <StyledButton onClick={this.handleClick}>View Visit Summary</StyledButton>
        </div>
      </div>
    );
  };

  render() {
    return (
      <FlowTransition
        flowState={this.props.flowState}
        stateToActivateFlow={ADD_REVIEW_THANK_YOU}
        toRender={this.renderThanks}
      />
    );
  }
}

const mapStateToProps = (state: any) => ({
  pastBookings: state.pastBookings,
});

const withStylesThankYou = withStyles(s)(ThankYou);
export default connect(mapStateToProps, null)(withStylesThankYou);
